import TestimonialsContainer from "../../container/admin/testimonials-master";

const Testimonials = () => {
    return <TestimonialsContainer />;
};

export default Testimonials;
